import { GET_USERS_SUCCESS } from '../constants/users.constants';
import { get } from '../../../../../shared/helpers';

export const transform_users_list = store => next => (action) => {
    if (action.type === GET_USERS_SUCCESS) {
        const _cells = ['person.first_name', 'person.last_name', 'login', 'person.ref_department.name'];

        action.payload.users = action.payload.users.map(row => ({
            cells: _cells.map(key => get(row, key)),
            ref_user_status: {
                name: row.ref_user_status.name,
                _id: row.ref_user_status._id,
            },
            ref_user_id: row._id,
            id: get(row, '_id'),
        }));
    }
    return next(action);
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/redux/middleware/transform_users_list.js